import IconHOC from '../IconHOC';

import { ReactComponent as SlidersIcon } from './sliders.svg';

export const Sliders = IconHOC(SlidersIcon);
